export default "__VITE_ASSET__BhD6BSAH__"